export const iconFontAwesomeWeatherHurricane = (
	<i className="fa-solid fa-hurricane"></i>
);
